/** Name und Wert des Darstellungs-Cookies — geteilt von Root-Layout (Server) und Schalter (Browser). */
export const DARSTELLUNG_COOKIE = 'paperball_theme';
export const DUNKEL = 'dark';
